exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.filter-list > li.item[data-v-2068c2c4] {\n  min-height: 34px;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n}\nul.filter-list > li.item > .svg-icon[data-v-2068c2c4] {\n  flex-shrink: 0;\n  margin-right: 5px;\n}\nul.filter-list > li.item > div > span[data-v-2068c2c4] {\n  flex-grow: 1;\n  overflow: hidden;\n  margin-right: 5px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\nul.filter-list > li.item > div > svg[data-v-2068c2c4] {\n  width: 18px;\n  height: 18px;\n  vertical-align: bottom;\n}\n", ""]);

// exports
